import React, { useState, useRef, FC, ReactElement } from "react";
import { GAAddToCart } from "scripts/components/ga/add_to_cart";
import FacebookPixel from "scripts/components/FacebookPixel/FBQ";
import eSputnik from "scripts/components/eSputnik";
import { GUID } from "scripts/utils";
import { addProduct } from "scripts/components/react/api/cart";
import { CartItemType } from "scripts/types/cart";
import { Credit } from "scripts/types/procuct";
interface CreditItemProps {
  price: number;
  credit: Credit;
  phrases?: any,
  onSendRequest: (showSpinner:boolean) => void
}

interface CartItems {
  [key: string]: CartItemType;
}

export const ModalCreditItem: FC<CreditItemProps> = ({ price, credit, phrases, onSendRequest }): ReactElement => {
  const [isCreditItemActive, setIsCreditItemActive] = useState<boolean>(false);
  const locale = useRef<string>(document.documentElement.lang).current;
  const perMonthPrefix =  locale === 'uk'|| locale === 'ru'? 'по' : 'of';

  const onSubmitButtonClick = async () => {
    const sizeId = window.currentProduct.value.id

    const redirect = () => {
      window.location.href = `/${locale !== "ru" ? `${locale}/` : ""}checkout/`;
    };

    if (window.productsIDs.includes(+sizeId)) {
      redirect();
    } else {
      onSendRequest(true);
      try {
        const { items, common  } : { items: CartItems, common: {} } = await addProduct({id: sizeId, locale, without_external_data: true})
        const addedItem = Object.entries(items).filter(
          (item) => item[1].id === +sizeId
        );
        //Analytics. Add to cart event. add_to_cart addToCart
        GAAddToCart(addedItem[0], common);
        FacebookPixel.addToCart(addedItem);
        eSputnik.StatusCart(items, new GUID())

        window.productsIDs.push(+sizeId);

        setTimeout(() => {
          redirect();
        }, 1000);
      } catch (e) {
        onSendRequest(false);
        console.error(e)
      }

    }
  }
  const priceFormat = (num, percent, price) => {
    const calc = Array.isArray(num)
      ? price / num[0] + (price * percent) / 100
      : price / num + (price * percent) / 100;

    return calc.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
  };

  const initialMonth = credit.code === "credit_privat_instant_installment"
    ? credit.month[credit.month.length - 1]
    : credit.month[0];

  const [pricePerMonth, setPricePerMonth] = useState<string>(
    priceFormat(initialMonth, credit.commission, price)
  );

  const creditItemClickHandler = (e) => {
    if (!e.target.closest('.tooltip-opener')) {
      setIsCreditItemActive(!isCreditItemActive)
    }
  }

  return (
    <div className={`credit-bank flex-c ${isCreditItemActive ? 'active' : ''}`}>
      <div className="suggest credit-bank__image flex-c" onClick={(e) => creditItemClickHandler(e)}>
        <div className="img"><img src={credit.icon} alt=""/></div>
        <div className="name">
          {credit.title}
        </div>
        <div className="info tooltip">
          <div className="info__tooltip tooltip__dropdown tooltip__outer">
            <p className="tooltip__text">{credit.description}</p>
          </div>
          <span className="tooltip-opener">
            <svg className="icon-info"><use href="#info-round"></use></svg>
          </span>
        </div>
        <svg className="icon-arrow">
          <use href="#arrow"></use>
        </svg>
      </div>
      <div className="credit-bank__content flex-c">
        <div className="commission">
          <span className="commission__title">{phrases.commission}</span>
          <div className="num">{credit.commission}%</div>
        </div>
        <div className="payment flex-c">
          <div className="payment__content flex-c">
            <div className="form-select error">
              <select
                className="js-credit-select credit__select"
                defaultValue={priceFormat(
                  credit.code === "credit_privat_instant_installment"
                    ? credit.month[credit.month.length - 1]
                    : credit.month[0],
                  credit.commission,
                  price
                )}
                onChange={(e) => setPricePerMonth(e.target.value)}
              >
                {credit.month.map((item) => {
                  return (
                    <option
                      key={item}
                      value={priceFormat(item, credit.commission, price)}
                    >
                      {item}
                    </option>
                  )
                })}
              </select>
            </div>
            <div className="credit-size">
              {perMonthPrefix} <span className="js-credit-result">{pricePerMonth}</span> ₴
            </div>
          </div>
          <button
            className="wb-btn btn-yellow"
            onClick={onSubmitButtonClick}
          >
            <span>{phrases.button}</span>
          </button>
        </div>
      </div>
    </div>
  )
}